import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { formatMarketingFigures } from '@/config/marketing';

export default function StatsSection() {
    const { t, i18n } = useTranslation(['admin']);
    const figures = formatMarketingFigures(i18n.language);
    const stats = [
        { value: figures.calls, label: t('admin:landing.stats.items.calls.label'), sublabel: t('admin:landing.stats.items.calls.sublabel') },
        { value: figures.meetings, label: t('admin:landing.stats.items.meetings.label'), sublabel: t('admin:landing.stats.items.meetings.sublabel') },
        { value: figures.firstMeeting, label: t('admin:landing.stats.items.firstMeeting.label'), sublabel: t('admin:landing.stats.items.firstMeeting.sublabel') },
        { value: figures.satisfaction, label: t('admin:landing.stats.items.satisfaction.label'), sublabel: t('admin:landing.stats.items.satisfaction.sublabel') },
    ];
    return (
        <section className="relative py-24 bg-[#0a0a0a]">
            <div className="max-w-6xl mx-auto px-6">
                <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
                    {stats.map((stat, index) => (
                        <motion.div
                            key={stat.label}
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.5, delay: index * 0.1 }}
                            className="text-center"
                        >
                            <div className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-1 md:mb-2">
                                {stat.value}
                            </div>
                            <div className="text-xs sm:text-sm text-white/60 font-medium">{stat.label}</div>
                            <div className="text-xs text-white/30 mt-1">{stat.sublabel}</div>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
}